module.exports = __webpack_public_path__ + "img/hoi-dap-nong-nghiep.e457622f.jpg";